import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { useExplorerGlobals } from "contexts/explorerGlobals";
import { CameraType, renderActions, selectCameraDefaults } from "features/render";

import { selectDefaultTopDownElevation, selectTopDownSnapToAxis } from "../orthoCamSlice";
import { getTopDownParams } from "../utils";

export function useGoTopDown() {
    const dispatch = useAppDispatch();
    const {
        state: { view },
    } = useExplorerGlobals();
    const defaultTopDownElevation = useAppSelector(selectDefaultTopDownElevation);
    const orthoFar = useAppSelector(selectCameraDefaults).orthographic.clipping.far;
    const snapToNearestAxis = useAppSelector(selectTopDownSnapToAxis) === undefined;

    return useCallback(async () => {
        if (!view) {
            return;
        }

        const isAlreadyTopDown = view.renderState.camera.kind === "orthographic" && view.isTopDown();
        if (isAlreadyTopDown) {
            return;
        }

        const { far, ...goTo } = await getTopDownParams({
            view,
            elevation: defaultTopDownElevation,
            snapToNearestAxis,
            far: orthoFar,
        });
        dispatch(
            renderActions.setCamera({
                type: CameraType.Orthographic,
                goTo,
            }),
        );

        if (far) {
            dispatch(renderActions.setCameraDefaults({ orthographic: { clipping: { far } } }));
        }
    }, [dispatch, view, defaultTopDownElevation, orthoFar, snapToNearestAxis]);
}
